import React, { useEffect } from 'react';
import { Layout } from 'antd';
import { Route, Routes, useNavigate } from 'react-router-dom';
import SidebarComponent from './sidebar';
import { useDispatch, useSelector } from 'react-redux';
import './index.less';
import LabSetup from '../LabSetup';
import LabDetail from '../LabSetup/labDetail';
import Departments from "../ActivityTypes";
import UserManager from "../UserManager";
import UserDetails from "../UserManager/userDetails";
import LabStatuses from "../LabStatuses";
import VarianceStatuses from "../VarianceStatuses";
import LandingPage from "../LandingPage";
import LabsStockManagement from "../LabsStockManagement";
import Dashboard from "../Dashboard";
// Import your page components here
// import Dashboard from '../Dashboard';
// import Settings from '../Settings';

const LayoutComponent = () => {
  const { Content } = Layout;
  const { user } = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    // Add any initialization logic here
  }, []);

  return (
    <Layout className="most-parent-layout">
      <Layout className="site-layout">
        <SidebarComponent />
        <Content className="layout-content site-layout-background">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="*" element={<LandingPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/labs-stock-management" element={<LabsStockManagement />} />
            <Route path="/labs-stock-management/:lab_id" element={<LabsStockManagement />} />
            {user?.permissions?.labs_setup?.view && (
              <>
                <Route path="/labs-setup" element={<LabSetup />} />
                <Route
                  path="/labs-setup/create-lab"
                  element={<LabDetail />}
                />
                <Route
                  path="/labs-setup/update-lab/:id"
                  element={<LabDetail />}
                />
              </>
            )}
            <Route path="/profile" element={<UserDetails />} />
            {/* <Route path="/settings" element={<div>Settings</div>} /> */}
            {user?.permissions?.user_manager?.view && (
              <>
                <Route
                  path="/settings/users-manager"
                  element={<UserManager />}
                />
                <Route
                  path="/settings/users-manager/create-user"
                  element={<UserDetails />}
                />
                <Route
                  path="/settings/users-manager/update-user/:id"
                  element={<UserDetails />}
                />
              </>
            )}
            {/* <Route path="/profile" element={<UserDetails />} /> */}
            {user?.permissions?.departments?.view && (
              <Route path="/settings/departments" element={<Departments />} />
            )}
            {/* Add more routes here */}
            {/* <Route path="/settings/inventory-products" element={<div>Inventory / Products</div>} /> */}
            {user?.permissions?.variance_statuses?.view && (
              <Route
                path="/settings/variance-statuses"
                element={<VarianceStatuses />}
              />
            )}
             {user?.permissions?.lab_statuses?.view && (
              <Route
                path="/settings/lab-statuses"
                element={<LabStatuses />}
              />
            )}
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default LayoutComponent;
